import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Head from '../components/Head';
import messages from '../lib/messages.mjs';
import HomeLink from '../components/HomeLink';

const ContactPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="contact"
      passHref
    >
      {intl.formatMessage(messages.contact)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.contact)}
        description={intl.formatMessage(messages.contact)}
      />
      <StaticPageComponent
        content={(
          <div className="contact-page">
            <h2>Get in touch with your local consultant</h2>
            <p className="description">
              To boost your marketing and HR strategy
              via jobs@fashionunited.com or phone:
            </p>
            <div className="countries-container">
              <div className="country">
                <div className="fu-image-container image-flag-ar">&nbsp;</div>
                <div className="fu-heading-bold">Argentina</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-au">&nbsp;</div>
                <div className="fu-heading-bold">Australia</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-be">&nbsp;</div>
                <div className="fu-heading-bold">Belgium</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-ca">&nbsp;</div>
                <div className="fu-heading-bold">Canada</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-cn">&nbsp;</div>
                <div className="fu-heading-bold">China</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-cl">&nbsp;</div>
                <div className="fu-heading-bold">Chile</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-co">&nbsp;</div>
                <div className="fu-heading-bold">Colombia</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-fr">&nbsp;</div>
                <div className="fu-heading-bold">France</div>
                <div className="fu-flag-text">+33 975 170 864</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-de">&nbsp;</div>
                <div className="fu-heading-bold">Germany</div>
                <div className="fu-flag-text">+31 20 262 2284</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-in">&nbsp;</div>
                <div className="fu-heading-bold">India</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-it">&nbsp;</div>
                <div className="fu-heading-bold">Italy</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-mx">&nbsp;</div>
                <div className="fu-heading-bold">Mexico</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-nl">&nbsp;</div>
                <div className="fu-heading-bold">The Netherlands</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-nz">&nbsp;</div>
                <div className="fu-heading-bold">New Zealand</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-pe">&nbsp;</div>
                <div className="fu-heading-bold">Peru</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-es">&nbsp;</div>
                <div className="fu-heading-bold">Spain</div>
                <div className="fu-flag-text">+34 931 846 718</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-ch">&nbsp;</div>
                <div className="fu-heading-bold">Switzerland</div>
                <div className="fu-flag-text">+31 20 615 4241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-gb">&nbsp;</div>
                <div className="fu-heading-bold">United Kingdom</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-us">&nbsp;</div>
                <div className="fu-heading-bold">USA</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
              <div className="country">
                <div className="fu-image-container image-flag-ru">&nbsp;</div>
                <div className="fu-heading-bold">Russia</div>
                <div className="fu-flag-text">+31 206 154 241</div>
              </div>
            </div>
            <h2>Get in Touch with the editorial Department</h2>
            <div className="editorial-container">
              <p className="description">
                For press releases, news and tips:
              </p>
              <p>+31 204084598</p>
              <p>news@fashionunited.com</p>
            </div>
            <h2>Need More Information?</h2>
            <div className="contact-container">
              <div className="contact">
                <h3>FashionUnited Media</h3>
                <p>Infonomy BV</p>
                <p>
                  Hoogoorddreef 56S
                  <br />
                  1101BE Amsterdam
                </p>
                <p>
                  Phone: +31 206154241
                  <br />
                  Email: media@fashionunited.com
                </p>
                <p>CEO: L.A. Minderhoud</p>
                <p>
                  Chefredakteurin: E. van Loon
                </p>
                <p>
                  KvK: 32078229
                  <br />
                  VAT/BTW: NL808503558B01
                  <br />
                  BIC code: INGBNL2A
                  <br />
                  IBAN code: NL81INGB0653082878
                </p>
              </div>
              <div className="contact">
                <h3>FashionUnited eBusiness</h3>
                <p>
                  Palmpolstraat 7
                  <br />
                  1327 CA Almere
                </p>
                <p>
                  Call us: + 31 850404866
                  <br />
                  (for technical support and general inquiries)
                </p>
                <p>
                  Chamber of Commerce: 17263340
                  <br />
                  VAT: NL 8213 01 019 B01
                </p>
              </div>
              <div className="contact">
                <h3>FashionUnited TV</h3>
                <p>
                  Hoogoorddreef 56S
                  <br />
                  1101BE Amsterdam
                </p>
                <p>
                  Phone: +31 206154241
                  <br />
                  Fax: +31 847565584
                  <br />
                  E-mail: media@fashionunited.com
                </p>
                <p>
                  KvK: 32078229
                  <br />
                  VAT/BTW: NL808503558B01
                </p>
              </div>
              <div className="contact">
                <h3>FashionUnited Career Centers</h3>
                <p>
                  Hoogoorddreef 56S
                  <br />
                  1101BE Amsterdam
                </p>
                <p>
                  Phone: +31 206154241
                  <br />
                  Fax: +31 847565584
                  <br />
                  E-mail: media@fashionunited.com
                </p>
              </div>
            </div>
          </div>
        )}
        title={intl.formatMessage(messages.contact)}
        breadcrumbs={breadcrumbs}
        disclaimer={(
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{
            __html: intl.formatMessage(messages['messages.contact.disclaimer']),
          }}
          />
        )}
      />
    </>
  );
};

ContactPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default ContactPage;
